export default __webpack_public_path__ + "media/images/rocket-66ab384c.png";